<t4-header icon="glyphicon-stats"></t4-header>
<t4-container>
  <mat-tab-group>
    <mat-tab label="Locks">
      <mat-form-field style="max-width:400px;">
        <mat-label>Groups</mat-label>
        <mat-select [formControl]="groupsControl" multiple (selectionChange)="applyFilter()">
          <mat-option *ngFor="let group of filterGroups" [value]="group">{{group}}</mat-option>
        </mat-select>
      </mat-form-field>

      <t4-data-table #lockTable headline="" matSort [rawData]="filteredLockData" [allowPaging]="true" [allowFilter]="true" [allowMultiSelect]="true" [filterFields]="['Location', 'LockId', 'LockMac', 'Trailer', 'UpdatedAt', 'Battery']" [autoGenerateColumns]="false">

        <ng-container matColumnDef="Id">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 100px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">Add Action</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ 'warning-background': (row.Battery < 2900 && row.Battery > 100), 'critical-background': (row.Battery < 2850 && row.Battery > 100)}" style="max-width: 100px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            <button mat-icon-button (click)="addAction(row)">
              <mat-icon>control_point</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="TrailerEnabled">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:125px;">Status</mat-header-cell>
          <mat-cell style="max-width:125px;" *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100) }">
            <mat-icon *ngIf="row.TrailerEnabled && row.Battery >= 2900" style="color: green">
              battery_full
            </mat-icon>
            <mat-icon *ngIf="!row.TrailerEnabled && row.Battery >= 2900" style="color: green">
              battery_full
            </mat-icon>
            <mat-icon *ngIf="row.TrailerEnabled && row.Battery < 2900 && row.Battery >= 2850 && row.Battery > 100" style="color: #dcaa1e">
              warning_amber
            </mat-icon>
            <mat-icon *ngIf="row.TrailerEnabled && row.Battery < 2850 && row.Battery > 100" style="color: #dcaa1e">
              battery_alert
            </mat-icon>
            <mat-icon *ngIf="!row.TrailerEnabled && row.Battery < 2800 && row.Battery > 100" style="color: #e52a16">
              battery_alert
            </mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Trailer">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Trailer</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }"><t4-object-link [objectId]="row.TrailerId">{{ row.Trailer }}</t4-object-link></mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Battery">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Battery</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100) }">
            <span *ngIf="row.Battery && row.Battery >= 3000">{{row.Battery}} (100%)</span>
            <span *ngIf="row.Battery && row.Battery < 3000 && (((row.Battery - 2800) / 200) * 100) > 0">{{row.Battery}} ({{ ((row.Battery - 2800) / 200) * 100 | number:'1.0-0' }}%)</span>
            <span *ngIf="row.Battery && row.Battery < 3000 && (((row.Battery - 2800) / 200) * 100) <= 0">{{row.Battery}} (0%)</span>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="UpdatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>UpdatedAt</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }">
            <span *ngIf="row.UpdatedAt">{{ row.UpdatedAt | date : 'yyyy-MM-dd HH:mm' }}</span>
            <span *ngIf="!row.UpdatedAt"></span>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Country</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }">{{row.Country}}</mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="Location">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Location</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }"><t4-location-link [locationId]="row.LocationId">{{row.Location}}</t4-location-link></mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="LockId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>LockId</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }">{{row.LockId}}</mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="LockMac">
          <mat-header-cell *matHeaderCellDef mat-sort-header>LockMac</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }">{{row.LockMac}}</mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="ActionExpire">
          <mat-header-cell *matHeaderCellDef mat-sort-header>ActionExpire</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }">{{row.ActionExpire | date : 'yyyy-MM-dd HH:mm'}}</mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="TrailerId" style="display: none">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="display: none">TrailerId</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }" style="display: none">{{row.TrailerId}}</mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee; display: none"></mat-footer-cell>
        </ng-container>
      </t4-data-table>
    </mat-tab>
    <mat-tab label="Action pending">
      <t4-data-table #tbl headline="" matSort [rawData]="actionPendingData" [filterFields]="['Location', 'LockId', 'LockMac', 'Trailer', 'UpdatedAt', 'Battery']" [autoGenerateColumns]="false">

        <ng-container matColumnDef="TrailerEnabled">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:125px;">Status</mat-header-cell>
          <mat-cell style="max-width:125px;" *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100) }">
            <mat-icon *ngIf="row.TrailerEnabled && row.Battery >= 2900" style="color: green">
              battery_full
            </mat-icon>
            <mat-icon *ngIf="!row.TrailerEnabled && row.Battery >= 2900" style="color: green">
              battery_full
            </mat-icon>
            <mat-icon *ngIf="row.TrailerEnabled && row.Battery < 2900 && row.Battery >= 2850 && row.Battery > 100" style="color: #dcaa1e">
              warning_amber
            </mat-icon>
            <mat-icon *ngIf="row.TrailerEnabled && row.Battery < 2850 && row.Battery > 100" style="color: #dcaa1e">
              battery_alert
            </mat-icon>
            <mat-icon *ngIf="!row.TrailerEnabled && row.Battery < 2800 && row.Battery > 100" style="color: #e52a16">
              battery_alert
            </mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Trailer">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Trailer</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }"><t4-object-link [objectId]="row.TrailerId">{{ row.Trailer }}</t4-object-link></mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Battery">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Battery</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100) }">
            <span *ngIf="row.Battery && row.Battery >= 3000">{{row.Battery}} (100%)</span>
            <span *ngIf="row.Battery && row.Battery < 3000 && (((row.Battery - 2800) / 200) * 100) > 0">{{row.Battery}} ({{ ((row.Battery - 2800) / 200) * 100 | number:'1.0-0' }}%)</span>
            <span *ngIf="row.Battery && row.Battery < 3000 && (((row.Battery - 2800) / 200) * 100) <= 0">{{row.Battery}} (0%)</span>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="UpdatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>UpdatedAt</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }">
            <span *ngIf="row.UpdatedAt">{{ row.UpdatedAt | date : 'yyyy-MM-dd HH:mm' }}</span>
            <span *ngIf="!row.UpdatedAt"></span>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Country</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }">{{row.Country}}</mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="Location">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Location</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }"><t4-location-link [locationId]="row.LocationId">{{row.Location}}</t4-location-link></mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="LockId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>LockId</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }">{{row.LockId}}</mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="LockMac">
          <mat-header-cell *matHeaderCellDef mat-sort-header>LockMac</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }">{{row.LockMac}}</mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="ActionExpire">
          <mat-header-cell *matHeaderCellDef mat-sort-header>ActionExpire</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }">{{row.ActionExpire | date : 'yyyy-MM-dd HH:mm'}}</mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="TrailerId" style="display: none">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="display: none">TrailerId</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ warning: (row.Battery < 2900 && row.Battery > 100), critical: (row.Battery < 2850 && row.Battery > 100)  }" style="display: none">{{row.TrailerId}}</mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee; display: none"></mat-footer-cell>
        </ng-container>
      </t4-data-table>
    </mat-tab>
</mat-tab-group>
</t4-container>
